import { motion } from "framer-motion";
import { Instagram as InstagramIcon, ArrowUpRight } from "lucide-react";
import { ASSETS, BRAND } from "../../data/content";
import { FadeUp, MaskLineInView } from "./Reveal";

// Display-only tiles (not clickable). Only the "Follow us" button links out.
const POSTS = [
  { src: ASSETS.igBua, alt: "Sharing jackfruit with the pup" },
  { src: ASSETS.igLights, alt: "Fairy lights after dark" },
  { src: ASSETS.igDsc0139, alt: "A quiet corner of the farm" },
  { src: ASSETS.igGardenRiverRapid, alt: "Where the garden meets the river" },
  { src: ASSETS.igGardenSide, alt: "The garden, unhurried" },
  { src: ASSETS.igKitchenGarlic, alt: "Garlic and tomatoes, straight to the kitchen" },
];

export const Instagram = () => {
  return (
    <section
      id="instagram"
      data-testid="instagram-section"
      className="bg-[#fbf8f0] py-12 lg:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
          <div className="max-w-2xl">
            <FadeUp>
              <span className="inline-flex items-center gap-2 font-body text-[#c56928] text-[13px] tracking-[0.3em] uppercase">
                <InstagramIcon size={14} /> Instagram
              </span>
            </FadeUp>
            <h2 className="font-display text-[#07412b] text-[52px] sm:text-7xl lg:text-[110px] mt-2 leading-[1]">
              <MaskLineInView>Latest from</MaskLineInView>
              <MaskLineInView delay={0.08} className="font-script text-[#ddb128] text-[42px] sm:text-6xl lg:text-[86px]">
                @thebrookatkhannasfarm
              </MaskLineInView>
            </h2>
          </div>
          <motion.a
            href={BRAND.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            className="self-start sm:self-end inline-flex items-center gap-2 rounded-full bg-[#07412b] text-[#f7f3e9] px-6 py-3 text-[12px] tracking-[0.16em] uppercase font-medium hover:bg-[#ddb128] hover:text-[#07412b] transition-colors"
          >
            Follow us
            <ArrowUpRight size={16} />
          </motion.a>
        </div>

        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 sm:gap-3">
          {POSTS.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`instagram-post-${i + 1}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: (i % 6) * 0.05 }}
              className="relative aspect-square overflow-hidden rounded-xl bg-[#07412b]/5 select-none"
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                decoding="async"
                draggable={false}
                className="h-full w-full object-cover pointer-events-none"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
